const { NETWORKS } = require("./services/coins_chain/networks");

const Exchanges = {
  binance: "binance",
  bitget: "bitget",
  gateio: "gateio",
  huobi: "huobi",
  kucoin: "kucoin",
  mxc: "mxc",
  whitebit: "whitebit",
  bitmart: "bitmart",
  probit: "probit",
  bybit: "bybit",
  okx: "okx",
  bitrue: "bitrue",
  xt: "xt",
  ascendex: "ascendex",
  "crypto-com": "crypto-com",
  kraken: "kraken",
  poloniex: "poloniex",
  bingx: "bingx",
  coinex: "coinex",
  lbank: "lbank",
  coinw: "coinw",
  phemex: "phemex",
  woox: "woox",
  tapbit: "tapbit",
  digifinex: "digifinex",
  bitfinex: "bitfinex",
  coinbase: "coinbase",
  bitstamp: "bitstamp",
  bitmex: "bitmex",
  bvox: "bvox",
  kcex: "kcex",
  // bitforex: "bitforex",
  // p2b: "p2b",
};

const fromExchanges = [
  "binance",
  "bitget",
  "gateio",
  "huobi",
  "kucoin",
  "mxc",
  "whitebit",
  "bitmart",
  "probit",
  "bybit",
  "okx",
  "bitrue",
  "xt",
  "ascendex",
  "crypto-com",
  "poloniex",
  "kraken",
  "coinex",
  "bingx",
  "lbank",
  "coinw",
  "phemex",
  "woox",
  "tapbit",
  "bitfinex",
  // "digifinex",
  // "p2b",
];
const toExchanges = [
  "binance",
  "bitget",
  "gateio",
  "huobi",
  "kucoin",
  "mxc",
  "whitebit",
  "bitmart",
  "probit",
  "bybit",
  "okx",
  "bitrue",
  "xt",
  "ascendex",
  "crypto-com",
  "poloniex",
  "kraken",
  "coinex",
  "bingx",
  // "lbank",
  "coinw",
  "phemex",
  "woox",
  "tapbit",
  "bitfinex",
  // "digifinex",
  // "p2b",
];

const NETWORKS_SCAN = {
  [NETWORKS.ETH]: (address, token) => ({
    base: "https://etherscan.io",
    tokentxns: token
      ? `https://etherscan.io/token/${token}?a=${address}`
      : `https://etherscan.io/address/${address}#tokentxns`,
    addresstxns: `https://etherscan.io/address/${address}#tokentxns`,
    tokenholdings: `https://etherscan.io/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.BSC]: (address, token) => ({
    base: "https://bscscan.com",
    tokentxns: token
      ? `https://bscscan.com/token/${token}?a=${address}`
      : `https://bscscan.com/address/${address}#tokentxns`,
    addresstxns: `https://bscscan.com/address/${address}#tokentxns`,
    tokenholdings: `https://bscscan.com/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.SOL]: (address) => ({
    base: "https://solscan.io",
    tokentxns: `https://solscan.io/account/${address}#splTransfers`,
    addresstxns: `https://solscan.io/account/${address}#splTransfers`,
    tokenholdings: `https://solscan.io/account/${address}#tokenAccounts`,
  }),
  [NETWORKS.MATIC]: (address, token) => ({
    base: "https://polygonscan.com",
    tokentxns: `https://polygonscan.com/address/${address}#tokentxns`,
    addresstxns: `https://polygonscan.com/address/${address}#tokentxns`,
    tokenholdings: `https://polygonscan.com/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.ARBITRUM]: (address, token) => ({
    base: "https://arbiscan.io",
    tokentxns: token
      ? `https://arbiscan.io/token/${token}?a=${address}`
      : `https://arbiscan.io/address/${address}#tokentxns`,
    addresstxns: `https://arbiscan.io/address/${address}#tokentxns`,
    tokenholdings: `https://arbiscan.io/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.BASE]: (address, token) => ({
    base: "https://basescan.org",
    tokentxns: token
      ? `https://basescan.org/token/${token}?a=${address}`
      : `https://basescan.org/address/${address}#tokentxns`,
    addresstxns: `https://basescan.org/address/${address}#tokentxns`,
    tokenholdings: `https://basescan.org/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.MANTLE]: (address, token) => ({
    base: "https://mantlescan.xyz",
    tokentxns: token
    ? `https://mantlescan.xyz/token/${token}?a=${address}`
    : `https://mantlescan.xyz/address/${address}#tokentxns`,
    addresstxns: `https://mantlescan.xyz/address/${address}#tokentxns`,
    tokenholdings: `https://mantlescan.xyz/tokenholdings?a=${address}`,
  }),
  [NETWORKS.CRO]: (address) => ({
    base: "https://cronoscan.com",
    tokentxns: `https://cronoscan.com/address/${address}#tokentxns`,
    addresstxns: `https://cronoscan.com/tokenholdings?a=${address}`,
    tokenholdings: `https://cronoscan.com/tokenholdings?a=${address}`,
  }),
  [NETWORKS.TRX]: (address) => ({
    base: "https://tronscan.org",
    tokentxns: `https://tronscan.org/#/address/${address}/transfers`,
    addresstxns: `https://tronscan.org/#/address/${address}/transfers`,
    tokenholdings: `https://tronscan.org/#/balanceView/${address}`,
  }),
  [NETWORKS.ARBITRUM_NOVA]: (address, token) => ({
    base: "https://nova.arbiscan.io",
    tokentxns: `https://nova.arbiscan.io/address/${address}#tokentxns`,
    addresstxns: `https://nova.arbiscan.io/address/${address}#tokentxns`,
    tokenholdings: `https://nova.arbiscan.io/tokenholdings?a=${address}&q=${token}`,
  }),
  [NETWORKS.DOT]: (address) => ({
    base: "https://polkadot.subscan.io",
    tokentxns: `https://polkadot.subscan.io/account/${address}?tab=transfer`,
    addresstxns: `https://polkadot.subscan.io/account/${address}?tab=transfer`,
    tokenholdings: `https://polkadot.subscan.io/account/${address}?tab=balance_history`,
  }),
  [NETWORKS.QIE]: (address) => ({
    base: "https://mainnet.qiblockchain.online",
    tokentxns: `https://mainnet.qiblockchain.online/address/${address}/transactions#address-tabs`,
    addresstxns: `https://mainnet.qiblockchain.online/address/${address}/transactions#address-tabs`,
    tokenholdings: `https://mainnet.qiblockchain.online/address/${address}/coin-balances#address-tabs`,
  }),
  [NETWORKS.TAO]: (address) => ({
    base: "https://x.taostats.io",
    tokentxns: `https://x.taostats.io/account/${address}`,
    addresstxns: `https://x.taostats.io/account/${address}`,
    tokenholdings: `https://x.taostats.io/account/${address}`,
  }),
  [NETWORKS.XRP]: (address) => ({
    base: "https://xrpscan.com",
    tokentxns: `https://xrpscan.com/account/${address}`,
    addresstxns: `https://xrpscan.com/account/${address}`,
    tokenholdings: `https://xrpscan.com/account/${address}`,
  }),
  [NETWORKS.MOVR]: (address) => ({
    base: "https://moonriver.moonscan.io",
    tokentxns: `https://moonriver.moonscan.io/address/${address}`,
    addresstxns: `https://moonriver.moonscan.io/address/${address}`,
    tokenholdings: `https://moonriver.moonscan.io/address/${address}`,
  }),
  [NETWORKS.BIZA]: (address) => ({
    base: "https://explorer.bizauto.io",
    tokentxns: `https://explorer.bizauto.io/account/${address}`,
    addresstxns: `https://explorer.bizauto.io/account/${address}`,
    tokenholdings: `https://explorer.bizauto.io/account/${address}`,
  }),
  [NETWORKS.BTC]: (address) => ({
    base: "https://www.okx.com/ru/explorer/btc",
    tokentxns: `https://www.okx.com/ru/explorer/btc/address/${address}?tab=tokenTransfer`,
    addresstxns: `https://www.okx.com/ru/explorer/btc/address/${address}?tab=tokenTransfer`,
    tokenholdings: `https://www.okx.com/ru/explorer/btc/address/${address}?tab=balance`,
  }),
  [NETWORKS.XDC]: (address) => ({
    base: "https://explorer.xinfin.network",
    tokentxns: `https://explorer.xinfin.network/address/${address}#XRC20TokenTxns`,
    addresstxns: `https://explorer.xinfin.network/address/${address}#XRC20TokenTxns`,
    tokenholdings: `https://explorer.xinfin.network/address/${address}#xrc20Holding`,
  }),
  [NETWORKS.FTM]: (address) => ({
    base: "https://ftmscan.com",
    tokentxns: `https://ftmscan.com/address/${address}#tokentxns`,
    addresstxns: `https://ftmscan.com/address/${address}#tokentxns`,
    tokenholdings: `https://ftmscan.com/tokenholdings?a=${address}`,
  }),
  [NETWORKS.GMMT]: (address) => ({
    base: "https://scan.gmmtchain.io",
    tokentxns: `https://scan.gmmtchain.io/address/${address}`,
    addresstxns: `https://scan.gmmtchain.io/address/${address}`,
    tokenholdings: `https://scan.gmmtchain.io/address/${address}`,
  }),
  [NETWORKS.DAG]: (address) => ({
    base: "https://mainnet.dagexplorer.io",
    tokentxns: `https://mainnet.dagexplorer.io/address/${address}`,
    addresstxns: `https://mainnet.dagexplorer.io/address/${address}`,
    tokenholdings: `https://mainnet.dagexplorer.io/address/${address}`,
  }),
  [NETWORKS.KLAY]: (address) => ({
    base: "https://scope.klaytn.com",
    tokentxns: `https://scope.klaytn.com/account/${address}?tabId=tokenTransfer`,
    addresstxns: `https://scope.klaytn.com/account/${address}?tabId=tokenTransfer`,
    tokenholdings: `https://scope.klaytn.com/account/${address}?tabId=tokenBalance`,
  }),
  [NETWORKS.AVAX_C]: (address) => ({
    base: "https://snowtrace.io",
    tokentxns: `https://snowtrace.io/address/${address}#tokentxns`,
    addresstxns: `https://snowtrace.io/address/${address}#tokentxns`,
    tokenholdings: `https://snowtrace.io/address/${address}#tokentxns`,
  }),
  [NETWORKS.XANA]: (address) => ({
    base: "https://avascan.info",
    tokentxns: `https://avascan.info/blockchain/xana/address/${address}/transactions`,
    addresstxns: `https://avascan.info/blockchain/xana/address/${address}/transactions`,
    tokenholdings: `https://avascan.info/blockchain/xana/address/${address}/transactions`,
  }),
  [NETWORKS.FRA]: (address) => ({
    base: "https://evm.findorascan.io",
    tokentxns: `https://evm.findorascan.io/address/${address}`,
    addresstxns: `https://evm.findorascan.io/address/${address}`,
    tokenholdings: `https://evm.findorascan.io/address/${address}`,
  }),
  [NETWORKS.ZIL]: (address) => ({
    base: "https://viewblock.io/zilliqa",
    tokentxns: `https://viewblock.io/zilliqa/address/${address}`,
    addresstxns: `https://viewblock.io/zilliqa/address/${address}`,
    tokenholdings: `https://viewblock.io/zilliqa/address/${address}`,
  }),
  [NETWORKS.CSPR]: (address) => ({
    base: "https://cspr.live",
    tokentxns: `https://cspr.live/account/${address}`,
    addresstxns: `https://cspr.live/account/${address}`,
    tokenholdings: `https://cspr.live/account/${address}`,
  }),
  [NETWORKS.SC]: (address) => ({
    base: "https://siascan.com",
    tokentxns: `https://siascan.com/address/${address}`,
    addresstxns: `https://siascan.com/address/${address}`,
    tokenholdings: `https://siascan.com/address/${address}`,
  }),
  [NETWORKS.LUNC]: (address) => ({
    base: "https://finder.terra.money",
    tokentxns: `https://finder.terra.money/columbus-5/address/${address}`,
    addresstxns: `https://finder.terra.money/columbus-5/address/${address}`,
    tokenholdings: `https://finder.terra.money/columbus-5/address/${address}`,
  }),
  [NETWORKS.RON]: (address) => ({
    base: "https://app.roninchain.com",
    tokentxns: `https://app.roninchain.com/address/${address}?t=activity`,
    addresstxns: `https://app.roninchain.com/address/${address}?t=activity`,
    tokenholdings: `https://app.roninchain.com/address/${address}?t=activity`,
  }),
  [NETWORKS.LSK]: (address) => ({
    base: "https://liskscan.com",
    tokentxns: `https://liskscan.com/account/${address}`,
    addresstxns: `https://liskscan.com/account/${address}`,
    tokenholdings: `https://liskscan.com/account/${address}`,
  }),
  [NETWORKS.WEMIX]: (address) => ({
    base: "https://wemixscan.com",
    tokentxns: `https://wemixscan.com/address/${address}`,
    addresstxns: `https://wemixscan.com/address/${address}`,
    tokenholdings: `https://wemixscan.com/address/${address}`,
  }),
  [NETWORKS.CKB]: (address) => ({
    base: "https://explorer.nervos.org",
    tokentxns: `https://explorer.nervos.org/address/${address}`,
    addresstxns: `https://explorer.nervos.org/address/${address}`,
    tokenholdings: `https://explorer.nervos.org/address/${address}`,
  }),
  [NETWORKS.VET]: (address) => ({
    base: "https://explore.vechain.org",
    tokentxns: `https://explore.vechain.org/accounts/${address}/transfer`,
    addresstxns: `https://explore.vechain.org/accounts/${address}/transfer`,
    tokenholdings: `https://explore.vechain.org/accounts/${address}/transfer`,
  }),
  [NETWORKS.CFXeSpace]: (address) => ({
    base: "https://evm.confluxscan.net",
    tokentxns: `https://evm.confluxscan.net/address/${address}?tab=transaction`,
    addresstxns: `https://evm.confluxscan.net/address/${address}?tab=transaction`,
    tokenholdings: `https://evm.confluxscan.net/address/${address}?tab=transaction`,
  }),
  [NETWORKS.AKT]: (address) => ({
    base: "https://www.mintscan.io",
    tokentxns: `https://www.mintscan.io/akash/address/${address}`,
    addresstxns: `https://www.mintscan.io/akash/address/${address}`,
    tokenholdings: `https://www.mintscan.io/akash/address/${address}`,
  }),
  [NETWORKS.AR]: (address) => ({
    base: "https://viewblock.io",
    tokentxns: `https://viewblock.io/arweave/address/${address}`,
    addresstxns: `https://viewblock.io/arweave/address/${address}`,
    tokenholdings: `https://viewblock.io/arweave/address/${address}`,
  }),
  [NETWORKS.POLYX]: (address) => ({
    base: "https://polymesh.subscan.io",
    tokentxns: `https://polymesh.subscan.io/account/${address}?tab=transfer`,
    addresstxns: `https://polymesh.subscan.io/account/${address}?tab=transfer`,
    tokenholdings: `https://polymesh.subscan.io/account/${address}?tab=transfer`,
  }),
  [NETWORKS.ALPH]: (address) => ({
    base: "https://explorer.alephium.org",
    tokentxns: `https://explorer.alephium.org/addresses/${address}`,
    addresstxns: `https://explorer.alephium.org/addresses/${address}`,
    tokenholdings: `https://explorer.alephium.org/addresses/${address}`,
  }),
  [NETWORKS.LINEA]: (address) => ({
    base: "https://linea.socialscan.io",
    tokentxns: `https://linea.socialscan.io/address/${address}#tokentxns`,
    addresstxns: `https://linea.socialscan.io/address/${address}#tokentxns`,
    tokenholdings: `https://linea.socialscan.io/address/${address}#tokentxns`,
  }),
  [NETWORKS.TON]: (address) => ({
    base: "https://tonviewer.com",
    tokentxns: `https://tonviewer.com/${address}`,
    addresstxns: `https://tonviewer.com/${address}`,
    tokenholdings: `https://tonviewer.com/${address}?section=tokens`,
  }),
  [NETWORKS.SUI]: (address) => ({
    base: "https://suiscan.xyz",
    tokentxns: `https://suiscan.xyz/mainnet/account/${address}`,
    addresstxns: `https://suiscan.xyz/mainnet/account/${address}/activity`,
    tokenholdings: `https://suiscan.xyz/mainnet/account/${address}/portfolio`,
  }),
};

const ExchangesAddresses = {
  [Exchanges.binance]: {
    [NETWORKS.ETH]: ["0x21a31ee1afc51d94c2efccaa2092ad1028285549"],
    [NETWORKS.BSC]: ["0xa180fe01b906a1be37be6c534a3300785b20d947"],
    [NETWORKS.TRX]: ["TQrY8tryqsYVCYS3MFbtffiPp2ccyn4STm"],
    [NETWORKS.SOL]: ["5tzFkiKscXHK5ZXCGbXZxdw7gTjjD1mBwuoFbhUvuAi9"],
    [NETWORKS.ARBITRUM]: ["0xb38e8c17e38363af6ebdcb3dae12e0243582891d"],
    [NETWORKS.SC]: ["225893741f8b7bcfc9a3d25eecb24d0c37a1db954f834c8aa590dda5dd49fca340692b35c77c"],
    [NETWORKS.CFXeSpace]: ["0x9c3f316bba32283bc5b8b16402acb89ec7db1a4d"],
  },
  [Exchanges.bitget]: {
    [NETWORKS.ARBITRUM]: ["0x5bdf85216ec1e38d6458c870992a69e38e03f7ef"],
    [NETWORKS.ETH]: [
      "0x5bdf85216ec1e38d6458c870992a69e38e03f7ef",
      "0x97b9d2102a9a65a26e1ee82d59e42d1b73b68689",
      "0x1ab4973a48dc892cd9971ece8e01dcc7688f8f23",
    ],
    [NETWORKS.FTM]: ["0x5bdf85216ec1e38d6458c870992a69e38e03f7ef"],
    [NETWORKS.BSC]: [
      "0x1ab4973a48dc892cd9971ece8e01dcc7688f8f23",
      "0x97b9d2102a9a65a26e1ee82d59e42d1b73b68689",
      "0x0639556f03714a74a5feeaf5736a4a64ff70d206",
    ],
    [NETWORKS.TRX]: ["TFrRVZFoHty7scd2a1q6BDxPU5fyqiB4iR"],
    [NETWORKS.DOT]: ["15u2N1pqWr56teREjQTP5M3tk1SPQjEoUAV6jFfcQCoVy3S5"],
    [NETWORKS.XANA]: ["0x5bdf85216ec1e38D6458C870992A69e38e03F7Ef"],
    [NETWORKS.BASE]: ["0x97b9D2102A9a65A26E1EE82D59e42d1B73B68689"],
  },
  [Exchanges.gateio]: {
    [NETWORKS.ETH]: ["0x0d0707963952f2fba59dd06f2b425ace40b492fe"],
    [NETWORKS.BSC]: ["0x0d0707963952f2fba59dd06f2b425ace40b492fe"],
    [NETWORKS.ARBITRUM]: ["0x0d0707963952f2fba59dd06f2b425ace40b492fe"],
    [NETWORKS.BASE]: ["0x0D0707963952f2fBA59dD06f2b425ace40b492Fe"],
    [NETWORKS.TRX]: ["TBA6CypYJizwA9XdC7Ubgc5F1bxrQ7SqPt"],
    [NETWORKS.SOL]: ["u6PJ8DtQuPFnfmwHbGFULQ4u4EgjDiyYKjVEsynXq2w"],
    [NETWORKS.MATIC]: ["0x0d0707963952f2fba59dd06f2b425ace40b492fe"],
    [NETWORKS.ZIL]: ["zil1e9k0rdjgh0khx06veut6ghwkggue6snmrlyg4w"],
    [NETWORKS.CSPR]: ["496d542527e1a29f576ab7c3f4c947bfcdc9b4145f75f6ec40e36089432d7351"],
    [NETWORKS.SUI]: ["0x62f36b79d7ea8ae189491854edd9318b29c75346792177b230a95f333ffa53ad"],
    [NETWORKS.MANTLE]: ["0x0d0707963952f2fba59dd06f2b425ace40b492fe"],
  },
  [Exchanges.huobi]: {
    [NETWORKS.ETH]: [
      "0xa03400e098f4421b34a3a44a1b4e571419517687",
      "0x4fb312915b779b1339388e14b6d079741ca83128",
      "0x18709e89bd403f470088abdacebe86cc60dda12e",
    ],
    [NETWORKS.BSC]: ["0xdd3cb5c974601bc3974d908ea4a86020f9999e0c"],
    [NETWORKS.TRX]: ["TFTWNgDBkQ5wQoP8RXpRznnHvAVV8x5jLu"],
    [NETWORKS.SOL]: ["BY4StcU9Y2BpgH8quZzorg31EGE4L1rjomN8FNsCBEcx"],
    [NETWORKS.AVAX_C]: ["0xa77ff0e1C52f58363a53282624C7BaA5fA91687D"],
    [NETWORKS.MATIC]: ["0x9a7ffd7f6c42ab805e0edf16c25101964c6326b6"],
    [NETWORKS.ARBITRUM]: ["0xce7ec11a5f306c6b896526149db1a86c7d1531e2"],
  },
  [Exchanges.kucoin]: {
    [NETWORKS.ETH]: [
      "0xcE0d2213A0eAFF4176D90B39879b7B4F870fA428",
      "0xd91efec7e42f80156d1d9f660a69847188950747",
      "0xf16e9b0d03470827a95cdfd0cb8a8a3b46969b91",
      "0x58edF78281334335EfFa23101bBe3371b6a36A51",
    ],
    [NETWORKS.BSC]: ["0x53f78a071d04224b8e254e243fffc6d9f2f3fa23"],
    [NETWORKS.TRX]: ["TUpHuDkiCCmwaTZBHZvQdwWzGNm5t8J2b9"],
    [NETWORKS.XDC]: ["xdc4e5d2ddf1c5060a64d70eec1731710f49a76d2bf"],
    [NETWORKS.DAG]: ["DAG6cStT1VYZdUhpoME23U5zbTveYq78tj7EihFV"],
    [NETWORKS.MATIC]: ["0x9AC5637d295FEA4f51E086C329d791cC157B1C84"],
    [NETWORKS.SOL]: ["BmFdpraQhkiDQE6SnfG5omcA1VwzqfXrwtNYBwWTymy6"],
    [NETWORKS.AVAX_C]: ["0x4E75e27e5Aa74F0c7A9D4897dC10EF651f3A3995"],
    [NETWORKS.ZIL]: ["zil1f4ce2tg6tfm3kyh98v5e2jtkjjmez6gasfcw6l"],
    [NETWORKS.CSPR]: ["49740daa2c2b02c657b748ae0fb98f55ca257ae24fa5a368c34b66fac3519c7d"],
    [NETWORKS.POLYX]: ["2EJz9EwEQ31jmKSQwQXH4uudNDbnJU1hK7cYU7jQiaKYaeuy"],
  },
  [Exchanges.mxc]: {
    [NETWORKS.ETH]: ["0x75e89d5979e4f6fba9f97c104c2f0afb3f1dcb88"],
    [NETWORKS.BSC]: ["0x4982085c9e2f89f2ecb8131eca71afad896e89cb"],
    [NETWORKS.TRX]: ["TEPSrSYPDSQ7yXpMFPq91Fb1QEWpMkRGfn"],
    [NETWORKS.ARBITRUM]: ["0x9b64203878f24eb0cdf55c8c6fa7d08ba0cf77e5"],
    [NETWORKS.MATIC]: ["0x51e3d44172868acc60d68ca99591ce4230bc75e0"],
    [NETWORKS.CRO]: ["0x17920846efD9BE87822F3e23360D763eC7F538C1"],
    [NETWORKS.TAO]: ["5FqBL928choLPmeFz5UVAvonBD5k7K2mZSXVC9RkFzLxoy2s"],
    [NETWORKS.XRP]: ["rs2dgzYeqYqsk8bvkQR5YPyqsXYcA24MP2"],
    [NETWORKS.BIZA]: ["bizamexcmexc"],
    [NETWORKS.XDC]: ["xdcf29f049144467b3dc55e19205c30c1737942f23a"],
    [NETWORKS.GMMT]: ["0xE252918263d8e06Fc6A6e413C5e683D09B2DeEDE"],
    [NETWORKS.DAG]: ["DAG6Yxge8Tzd8DJDJeL4hMLntnhheHGR4DYSPQvf"],
    [NETWORKS.KLAY]: ["0x9dd35021d77c1de5ed50b9d788a2f68903a96b96"],
    [NETWORKS.SOL]: ["ASTyfSima4LLAdDgoFGkgqoKowG1LZFDr9fAQrg7iaJZ"],
    [NETWORKS.AVAX_C]: ["0xffB3118124cdaEbD9095fA9a479895042018cac2"],
    [NETWORKS.MANTLE]: ["0x5c30940a4544ca845272fe97c4a27f2ed2cd7b64"],
  },
  [Exchanges.whitebit]: {
    [NETWORKS.ETH]: ["0x39f6a6c85d39d5abad8a398310c52e7c374f2ba3"],
    [NETWORKS.BSC]: ["0x33eac50b7faf4b8842a621d0475335693f5d21fe"],
    [NETWORKS.TRX]: ["TWBPGLwQw2EbqYLLw1DJnTDt2ZQ9yJW1JJ"],
  },
  [Exchanges.bitmart]: {
    [NETWORKS.ETH]: [
      "0x3ab28ecedea6cdb6feed398e93ae8c7b316b1182",
      "0x6D0D19bddDC5ED1dD501430c9621DD37ebd9062d",
      "0x7563758243a262e96880f178aee7817dcf47ab0f",
      "0x2982bB64bcd07Ac3315C32Cb2BB7e5E8a2De7d67",
    ],
    [NETWORKS.BSC]: [
      "0xa23ef2319ba4c933ebfdba80c332664a6cb13f1a",
      "0xeacb50a28630a4c44a884158ee85cbc10d2b3f10",
      "0x328130164d0f2b9d7a52edc73b3632e713ff0ec6",
      "0x7563758243a262e96880f178aee7817dcf47ab0f",
    ],
    [NETWORKS.SOL]: [
      "Hf7uXpMgqoaYtKEMD5DBgL9wJq9CUkqkZaAFCBNMNH7Q",
      "CgANddXc7FKSsdLSdFv67X8faZqQaRTeLMXkAVANkZD4",
    ],
    [NETWORKS.TRX]: ["TQNheVnmrtnJ2KRUuePBhJWQWhFmPjX7iH"],
    [NETWORKS.MATIC]: [
      "0xe9ee9f2857b559c67dd03576a1c74589a6af6197",
      "0x5c7bed3cca42e4562877ed88b9aa0f5898ed59b0",
    ],
    [NETWORKS.BIZA]: ["bitmartbiza2"],
    [NETWORKS.BTC]: ["37RJkdkzPXCMYSTq74berJYj9FmNn7wFP5"],
    [NETWORKS.GMMT]: ["0x1B11717090131162fB3f54843228524b51d7dBC3"],
    [NETWORKS.FRA]: ["0xce1aA6Cb8646B0cfB6f670e3C0A98431cAC503b2"],
    [NETWORKS.AVAX_C]: ["0xee937A6667E52957469f41Bf5326e6a73477b721"],
    [NETWORKS.CFXeSpace]: ["0x994b0eac7772ae972da0b9bc51427597941820b7"],
    [NETWORKS.CRO]: ["0x9910122ec07ea0d6a50bba03a5ec789ab9f29b9a"],
    [NETWORKS.base]: ["0xc3F6b6c4309Ba9A9887216DbeBf39FAC78406696"],
  },
  [Exchanges.probit]: {
    [NETWORKS.ETH]: ["0x72e5263ff33d2494692d7f94a758aa9f82062f73"],
    [NETWORKS.BSC]: ["0xf4be044ba7461d8444ed53f9ec7490781e08e3b7"],
    [NETWORKS.TRX]: ["TGEwJxVErWagXnriZATPMBFFbbeuad9m3h"],
    [NETWORKS.MATIC]: ["0xdba24f19bce0f32ea4273faea7c01d7f9d4f91d6"],
    [NETWORKS.BIZA]: ["bizawalletht"],
    [NETWORKS.XDC]: ["xdc3bfd061d3c39d6db3c04e1db0feca4fdb59668c8"],
    [NETWORKS.KLAY]: ["0xe102019b1ecb134b3043c12d25c8280c96d252d2"],
    [NETWORKS.SOL]: ["FavWP1KXVVNZLTYjfSBWPanxbVeCW4A3pJ96hn2GRWGR"],
    [NETWORKS.AVAX_C]: ["0xfE5504eF8Ea4392536383215be72C68312C0Ed95"],
  },
  [Exchanges.bybit]: {
    [NETWORKS.ETH]: ["0xf89d7b9c864f589bbf53a82105107622b35eaa40"],
    [NETWORKS.BSC]: ["0xf89d7b9c864f589bbf53a82105107622b35eaa40"],
    [NETWORKS.TRX]: ["TU4vEruvZwLLkSfV9bNw12EJTPvNr7Pvaa"],
    [NETWORKS.SOL]: ["AC5RDfQFmDS1deWZos921JfqscXdByf8BKHs5ACWjtW2"],
    [NETWORKS.XDC]: ["xdcd0ad6bc1c9e6fd9fc1be1d674109e1afcc78b058"],
    [NETWORKS.ARBITRUM]: ["0xf89d7b9c864f589bbf53a82105107622b35eaa40"],
    [NETWORKS.AVAX_C]: ["0xf89d7b9c864f589bbF53a82105107622B35EaA40"],
    [NETWORKS.WEMIX]: ["0xf89d7b9c864f589bbF53a82105107622B35EaA40"],
  },
  [Exchanges.okx]: {
    [NETWORKS.ETH]: ["0x6cC5F688a315f3dC28A7781717a9A798a59fDA7b"],
    [NETWORKS.TRX]: ["TJbHp48Shg4tTD5x6fKkU7PodggL5mjcJP"],
    [NETWORKS.XANA]: ["0x1ad687e0E924df0bf1566F09b10fBC68cBCa06e5"],
  },
  [Exchanges.bitrue]: {
    [NETWORKS.ETH]: ["0x6cc8dcbca746a6e4fdefb98e1d0df903b107fd21"],
    [NETWORKS.BSC]: ["0x868f027a5e3bd1cd29606a6681c3ddb7d3dd9b67"],
    [NETWORKS.MATIC]: ["0xa813251e163766361adfb9700748397977a54ea0"],
    [NETWORKS.SOL]: ["7RmkMNQerKaVioRnmqZsHM5Gm8F3gngQG8umLNoK97q4"],
    [NETWORKS.XDC]: ["xdcc1b519019639c7e684c6626440b448582cbe0a75"],
    [NETWORKS.DAG]: ["DAG4jFXdsWe6usU8LfJQaEus3MUN5hYxVVzFvNJk"],
    [NETWORKS.XRP]: ["r3RaNVLvWjqqtFAawC6jbRhgKyFH7HvRS8"],
    [NETWORKS.POLYX]: ["2HGzVfUSeKodJmRktP1uznFhyDL8kDb5TCPUjAWAxdKpArDu"],
    [NETWORKS.ALPH]: ["1FxnmVhFoEKbeFGqUSGB1oLD1mEUnxoXX1n58XxR4Uwx3"],
    [NETWORKS.CKB]: ["ckb1qzda0cr08m85hc8jlnfp3zer7xulejywt49kt2rr0vthywaa50xwsqtdjuar2g05de847e74dxz2k258xc0pgncsc8jtk"],
    [NETWORKS.CSPR]: ["0124481695bf1971ffef27bac7a069c53ccaa34e60bef27658232673f5e2f0db56"],
    // [NETWORKS.COREUM]: ["core1g2c72hh78wma9fqlva9wu5a9hx5vq8aeznltds"],
  },
  // [Exchanges.hotbit]: {
  //   [NETWORKS.ETH]: "0x562680a4dc50ed2f14d75bf31f494cfe0b8d10a1",
  //   [NETWORKS.BSC]: "0xc7029e939075f48fa2d5953381660c7d01570171",
  //   [NETWORKS.ARBITRUM]: "0xd690a9dfd7e4b02898cdd1a9e50ed1fd7d3d3442",
  //   [NETWORKS.SOL]: "9MuEFic64weCV9abrXbm4La9Un7NZopPfi4t8NFLZSkZ",
  //   [NETWORKS.TRX]: "TFPqi7KTRwi2tihwS5dp1QomHowp1x2f45",
  // },
  [Exchanges.xt]: {
    [NETWORKS.ETH]: ["0xdb3ded7731c781224ec292e2163d9554c094fd7c", "0xe0a616c3659be29567e08819772e6905307adf21"],
    [NETWORKS.BSC]: ["0xe0a616c3659be29567e08819772e6905307adf21"],
    [NETWORKS.QIE]: ["0xE0a616C3659bE29567E08819772e6905307AdF21"],
    [NETWORKS.BASE]: ["0xdb3ded7731c781224ec292e2163d9554c094fd7c", "0xE0a616C3659bE29567E08819772e6905307AdF21"],
    [NETWORKS.SOL]: ["41uCv6a1JPwZT4pDAN4AGvPosHVx2ndkNFEFgKLzd5wx"],
    [NETWORKS.MATIC]: ["0xe0a616c3659be29567e08819772e6905307adf21"],
    [NETWORKS.AVAX_C]: ["0xE0a616C3659bE29567E08819772e6905307AdF21"],
  },
  [Exchanges.ascendex]: {
    [NETWORKS.ETH]: [
      "0x983873529f95132bd1812a3b52c98fb271d2f679",
      "0x4240781a9ebdb2eb14a183466e8820978b7da4e2",
    ],
    [NETWORKS.SOL]: [
      "6iVBAsquJRaLsXbojb18kqTW1d5iVLspVjCtsReZBKhY",
    ],
    [NETWORKS.BSC]: [
      "0x983873529f95132bd1812a3b52c98fb271d2f679",
      "0x80Ca27268d4603E00B8d4D98Aa309dB438127d19",
    ],
    [NETWORKS.ZIL]: ["zil1z3knlvk3gatt9w29wzp4a4gfyj979td28myw3n"],
    [NETWORKS.AKT]: ["akash1vvua6aae5v54zmdud4fwuhsmzmcrle869kuza5"],
    [NETWORKS.CSPR]: ["01639e7e3acf3b5299d476f4dc82350245036847c28410497be3a8b11a2f90f8e4"],
    [NETWORKS.MATIC]: ["0x983873529f95132bd1812a3b52c98fb271d2f679"],
  },
  [Exchanges["crypto-com"]]: {
    [NETWORKS.ETH]: [
      "0x46340b20830761efd32832a74d7169b29feb9758",
      "0xcffad3200574698b78f32232aa9d63eabd290703",
    ],
    [NETWORKS.BSC]: ["0x625b02b687ec38f3085af5b108dda410775fa76a"],
    [NETWORKS.MOVR]: ["0x16c06ff6197b2c2d8b572dba7aa9b81615915fca"],
    [NETWORKS.CRO]: ["0xc9219731adfa70645be14cd5d30507266f2092c5"],
    [NETWORKS.MATIC]: ["0xfa0b641678f5115ad8a8de5752016bd1359681b9"],
    [NETWORKS.ARBITRUM_NOVA]: ["0xd45e1a851acae058caa0d4ccca0c9b28d4b63ccc"],
    [NETWORKS.ARBITRUM]: ["0xd7a827fbaf38c98e8336c5658e4bcbcd20a4fd2d"],
    [NETWORKS.AVAX_C]: ["0x187b2d576ba7ec2141c180A96eDd0f202492f36B"],
    [NETWORKS.SOL]: [
      "AobVSwdW9BbpMdJvTqeCN4hPAmh4rHm7vwLnQ5ATSyrS",
      "6FEVkH17P9y8Q9aCkDdPcMDjvj7SVxrTETaYEm8f51Jy",
    ],
    [NETWORKS.CSPR]: ["020396133b3bbbfcf7d1961390f9449e2de5813523180376df361cb31a1ca965b576"],
    [NETWORKS.SC]: ["e1fc58ff8865410ccf1c2f4270866639f1054d7c565cf237d77dfa0fde9972d458e1e0d32242"],
    [NETWORKS.LUNC]: ["terra1vyqu70zp92ljg0g3xwh9028hfyjzuhlrxlwn2f"],
    [NETWORKS.RON]: ["0x5d7f8c6484df522e604380a394d1fb4f4d9f42f3"],
    [NETWORKS.LSK]: ["lsk9w9qc6vs4d3qyqh322n69pebc2fdvsy4xsg5c9"],
    [NETWORKS.WEMIX]: ["0x9ba5b61491c711a056c82f3446087a2a4b19a114"],
    [NETWORKS.CKB]: ["ckb1qzda0cr08m85hc8jlnfp3zer7xulejywt49kt2rr0vthywaa50xwsqwdr5q4rwruykhehd8hn6gxh892wtmdprcw3h3ce"],
    [NETWORKS.VET]: ["0x4703582c50fcd1b65fab573bd02c1c53bbe05f92"],
    [NETWORKS.AR]: ["njT2r7p6AoeVyLww8ah8yUUA0SBwUYLpJ_9S0BXUHgc"],
  },
  [Exchanges.poloniex]: {
    [NETWORKS.ETH]: ["0x8fca4ade3a517133ff23ca55cdaea29c78c990b8"],
    [NETWORKS.BSC]: ["0x4068626796a4ffb573452d5297db134371a33a1c"],
    [NETWORKS.BASE]: ["0x5929b50B6AdCb10B7656D75e1aF9719cB3a2877F"],
    [NETWORKS.MATIC]: ["0xcc0c098f170281810966b4133c794cb91c5587b2"],
    [NETWORKS.ARBITRUM]: ["0x920021936b28c93491a02f760fa20aa599083ed5"],
    [NETWORKS.TRX]: ["TWhDfwC8QE6pQyiYy248dNor3uphPEw5M2"],
  },
  [Exchanges.kraken]: {
    [NETWORKS.ARBITRUM_NOVA]: ["0x25365753e2f7d0e945f071d5ca94861c66fef181"],
    [NETWORKS.SOL]: ["FWznbcNXWQuHTawe9RxvQ2LdCENssh12dsznf4RiouN5"],
  },
  [Exchanges.bingx]: {
    [NETWORKS.ETH]: ["0xd38cf87f114f2a0582c329fb9df4f7044ce71330"],
    [NETWORKS.BSC]: ["0xD38Cf87F114f2a0582c329Fb9df4f7044CE71330"],
    [NETWORKS.SOL]: ["AbbnxVgv4pJmBtBXKHH33ZLghJF4h8Bp7SyLPoxJSLXk"],
    [NETWORKS.ARBITRUM]: ["0xd38cf87f114f2a0582c329fb9df4f7044ce71330"],
    [NETWORKS.BASE]: ["0xd38cf87f114f2a0582c329fb9df4f7044ce71330"],
  },
  [Exchanges.coinex]: {
    [NETWORKS.ETH]: [
      "0xcf7105fde573695d62666aefa4e1691bf3ab50d5",
      "0x0802dd2edd3f9fad39a9173b4595be819f201d61",
      "0x8da2931006453e0285682314af5bcd2377deaeb1",
    ],
    [NETWORKS.BSC]: ["0xe70b8dc28e795738a772379e9d456e7d74f50ab5"],
    [NETWORKS.BASE]: ["0x20e3438BB64854C745405b166E96EBda80800723"],
    [NETWORKS.AVAX_C]: ["0x7baf813c087756b0ab66cC2Ab7E64f76C3998D81"],
    [NETWORKS.ARBITRUM_NOVA]: ["0x727129c38fec2e9b867973a7879fffd1ba68b560"],
    [NETWORKS.SOL]: ["3eGdjMdQqFUNc4G64BZb7YCALDEaturLUWcixjJfKxEh"],
    [NETWORKS.TON]: ["UQBQxO3LFg9IquauGcRo55ouXbhWLPJyvj0iyAia3MwcawwP"]
  },
  [Exchanges.lbank]: {
    [NETWORKS.SOL]: ["8s9j5qUtuE9PGA5s7QeAXEh5oc2UGr71pmJXgyiZMHkt"],
    [NETWORKS.MATIC]: ["0xec174c25bba7359b56fd672c8899664121e7dbcf"],
    [NETWORKS.ARBITRUM]: ["0xc06e0513a150a021104fdcdd20ce362fa593ba1f"],
    [NETWORKS.BSC]: ["0x124d9bf2fecbc16b54ec4accdb14d44c2144f012"],
    [NETWORKS.ETH]: ["0x120051a72966950b8ce12eb5496b5d1eeec1541b"],
    [NETWORKS.LINEA]: ["0xf8a3a22ea8152a4d3d5a9acc33bc0c88639ff401"],
    [NETWORKS.BASE]: ["0xf8a3A22ea8152A4d3d5a9aCC33BC0c88639fF401"],
    [NETWORKS.SUI]: ["0x6cb04412036e910e5fc2237c69d154bb0f69e48a75b030f6919f044f485c8307"],
  },
  [Exchanges.coinw]: {
    [NETWORKS.ETH]: [
      "0x43b719b9c6cf849dca549765ba1af00f3dfc4ac1",
      "0xf6deb02e24858887d2adbc713bf086de776a4be3",
      "0xfb30ed3485b30303965fcbac84d6e7bf239e75f7",
    ],
    [NETWORKS.AVAX_C]: ["0x7787718b48c93a22a77bC0450857F31D4702Ee57"],
    [NETWORKS.SOL]: ["8JWVtS21nfQddQR5thDQ8bL5ykHKAGLcYSdR3uQqBvoG"],
    [NETWORKS.BSC]: ["0xa003d2e887974ee61251ccf0a770558e239be599"],
  },
  [Exchanges.phemex]: {
    [NETWORKS.ETH]: ["0x50be13b54f3eebbe415d20250598d81280e56772"],
    [NETWORKS.BSC]: ["0x50be13b54f3eebbe415d20250598d81280e56772"],
    [NETWORKS.TAO]: ["5EBf59iVXqMQL7aECWRymyg8uQ2XGWF4xZCcEM6CM9iuYuT1"],
    [NETWORKS.BASE]: ["0x50BE13b54f3EeBBe415d20250598D81280e56772"],
    [NETWORKS.SOL]: ["EWSHJzKpzjpwz9GuNKkXWMHXAiwtB7obSGhdFKu5QZku"],
    [NETWORKS.CKB]: ["ckb1qzda0cr08m85hc8jlnfp3zer7xulejywt49kt2rr0vthywaa50xwsqd7xrmx3r279ud2galke6c0zvej5wd5u7g0s7mye"],
  },
  [Exchanges.woox]: {
    [NETWORKS.BASE]: ["0x63DFE4e34A3bFC00eB0220786238a7C6cEF8Ffc4", "0xdc0858E53EFe8a1F52EA25528f0D31572C3d07f1"],
    [NETWORKS.SOL]: ["6dUaYX9Z6aQPY66BgD4yzu1saifGAZLrhQqF9BugJxJ1"],
    [NETWORKS.BSC]: ["0x63dfe4e34a3bfc00eb0220786238a7c6cef8ffc4"],
    [NETWORKS.MANTLE]: ["0x63dfe4e34a3bfc00eb0220786238a7c6cef8ffc4"],
    [NETWORKS.CKB]: ["ckb1qzda0cr08m85hc8jlnfp3zer7xulejywt49kt2rr0vthywaa50xwsqgyy000nyw2vusqvhqnhpclqay3ppme74q30qusp"],
    [NETWORKS.ETH]: [
      "0xb8001c3ec9aa1985f6c747e25c28324e4a361ec1",
      "0x63dfe4e34a3bfc00eb0220786238a7c6cef8ffc4",
    ],
  },
  [Exchanges.digifinex]: {
    [NETWORKS.ETH]: ["0x6666827e8f2220ddf718193544889f3b482ed072"],
    [NETWORKS.BSC]: ["0xffefe959d8baea028b1697abfc4285028d6ceb10"],
  },
  [Exchanges.bitfinex]: {
    [NETWORKS.TRX]: ["TXFBqBbqJommqZf7BV8NNYzePh97UmJodJ"],
  },
  [Exchanges.kcex]: {
    [NETWORKS.ETH]: ["0xb8001c3ec9aa1985f6c747e25c28324e4a361ec1"],
    [NETWORKS.BSC]: ["0xbf957e1c121fa769580d29bf320ee8bff138ad12"],
  },
};

const ignoreExchanges = ["dodobsc", "zb", "aex"];

const ignoreCoins = [
  "kardiachain",
  "mdex",
  "richquack-com",
  "squid-grow",
  "bitgert",
  "pitbull",
  "defi-yield-protocol",
  "matrix-ai-network",
  "originate-coin",
  "baby-doge-coin",
  "empire-token",
  "volt-inu",
  "zombie-inu",
  "australian-safe-shepherd",
  "saitarealty",
  "kishu-inu",
  "terareum",
  "luna",
  "safemoon-v2",
  "pig-finance",
  "meta-ruffy",
  "hamster",
  "saitama-inu-new",
  "shyft-network",
  "binaryx",
  "amazingteamdao",
  "cryptocurrency-moons",
  "xmon",
  "loop-network",
  "floki-ceo",
  "luffy",
  "feg",
  "flexcoin",
  "iron-fish",
  "oggy-inu",
  "trump-inu-token",
  "bitcoin-gold",
  "bitcoin-sv",
  "piza-brc-20",
  "furucombo",
  "ramifi-protocol",
  "quint",
  "functionx-probit",
  "anchor-protocol-gateio",
  "wrappednxm-gateio",
  "kaizen-finance-gateio",
  "hshare-gateio",
  "vmpx-ascendex",
  "aeternity",
  "voxel-x-network-bitget",
  "landofconquest-gateio",
  "cyberconnect-gateio",
  "muratiai",
  "velodrome-finance-bitget",
  "deus-finance-gateio",
  "openleverage-gateio",
  "terra-virtua-kolect-bybit",
  "reality-metaverse-bybit",
  "gst-gateio",
  "gamee-gateio",
  "lybra-finance-okx",
  "cryptogpt-mxc",
  "layerium",
  "bitcoin-diamond",
  "pixelverse",
  "ontology-coinex",
  "wall-street-memes-bingx",
  "pepe-2-0-eth",
  "bitcoin-cats",
  "orange-brc",
  "zkpepe-2-mxc",
  "pikaboss-mxc",
  "marinade-new-bitrue",
  "torn-bingx",
  "agii-ai-lbank",
  "paris-saint-germain-fan-token-bybit",
  "mcontent",
  "welsh-corgi-coin",
  "memeai",
  "fc-barcelona-fan-token",
  "fluxbot",
  "nada",
  "ainn", // brc20
  "lithosphere",
  "omnicat-bybit",
  "roost-bitrue",
  "roost-ascendex",
  "gas-dao-lbank",
  "pawswap-lbank",
  "cat-coin-meme-coinex",
];

const ignoreCoinsMarket = [
  10641, // richquack 24% fee
  11079, // bitgert/Brise 12% fee
  9177, // pitbull  4+4% fee
  10336, // hamster - HAM 12% fee
  9456, //  ASS 10+10% fee
  18761, // loop-network 10+10% fee
  28381, // fluxb fees
  8829, // PIG 5+5% fee
  23641, // FLOKICEO 10+10% fee
  "21217-xt", // MMIT  1m need precision
  "24102-coinex", // PAW  diff contract
  "4769-lbank", // EOSC disabled w
  "2943-lbank", // RPL fake book
  14849, // CENX 12% fee
  2083, // BTG slow network
  25164, // PIZA BRC slow network
  28663, // MMSS slow btc network
  2222, // BCD slow btc network
  28755, // btcs slow btc network
  28775, // MICE slow btc network
  8292, // ROUTE old
  "10407-xt", // BabyDoge 10+10% fee
  19755, // BURN
  10954, // MCONTENT
  29079, // WELSH
  9892, // YooShi
  29026, // memeai  fee 10%
  28310, // PMPY
  29186, // PEAS
  29297,
  5225, // BAR
  18006, // future
  25208, // TRAC
  9386, // KISHU
  28451, // PUMP
  9089, // 10SET
  3709, // GRIN
  17972, // RBT
  30412, // DOGITA
  8977, // CWIF
  28993, // AINN BRC20
  "32074-coinw", // FEG diff contract
  "7226-kraken", // INJ
  "30407-bitrue", // ROOST
  "20500-huobi", // REVO
  "10861-xt", // GAME
  "26994-xt", // SMILEY
  "28675-xt", // COQ
  "29295-xt", // ZUZALU
  "29220-xt", // PORK
  "9674-xt", // WILD
  16500, // SHIBDOGE
  "19686-bitrue", // MNTL
  "14271-bitrue",
  "8857-gateio", // ANC
  "15881-bitget", // VXL
  "11869-gateio", // REALM
  "21036-gateio", // SLG
  "11933-gateio", // PIZA
  "24781-gateio", // PIZA
  "5858-gateio", // QANX
  "12972-gateio", // DEUS
  "20513-gateio", // SAITAMA
  "9103-gateio", // GAMEE
  "20719-gateio", // OLE
  "16352-gateio", // GST
  "24700-okx", // LBR
  "24700-bitrue", // LBR
  "20435-bitrue", // VELO
  "23195-bitrue", // ACS
  "26532-bitmart", // PIKA
  "9176-bitmart", // RVF
  "1958-poloniex", // RVF
  "8037-bybit", // TVK
  "28827-bybit", // omni
  "8037-kraken", // TVK
  "28321-kraken", // POL
  "6780-gateio", // EQ
  "2394-bingx", // TEL
  "24268-bingx", // THL
  "25125-bingx", // CAPO
  "6187-bitrue", // SRM
  "9892-bitrue", // YOOSHI
  "27276-bitrue", // PEPE2
  "27276-bybit", // PEPE2
  "5226-bybit", // PSG
  "11021-mxc", // CO
  "15931-mxc", // FROG
  "12279-mxc", // PIXEL
  "26532-mxc", // PIKA
  "22125-lbank", // MITH
  "6951-lbank", // reef
  "23487-lbank", // ozone
  "28151-lbank", // evadore
  "28647-lbank", // catboy
  "29291-lbank", // pandora
  "19891-lbank", // USDD
  "28660-lbank", // LVN
  "24050-probit", // PMG
  "28179-bingx", // WSM
  "13803-bitrue", // mnde
  "24537-mxc", // ZKPEPE
  "17722-mxc", // wallet
  "28247-lbank", // REKT
  "12043-lbank", // OCT
  "28672-lbank", // AGII
  "30087-mxc", // AAI
  31288, // TRIO
  27872, // TRUMP 2% fee
  "8936-coinex", // TRIAS
  "ccxt-NEIRO-coinw",
  "21465-bitmart", // MAX
  "15484-lbank", // LITHO
  "26788-bybit", // CAT
  "32776-huobi", // wukong
  "ccxt-PNUT-poloniex", // wukong
  "ccxt-COW-probit", // cow
  30484, // PUPS ordinals

  // temp
  "11877-woox", // GAL
  "5690-woox", // RNDR
  "21106-woox", // RDNT
  "5200-lbank", // GLEEC
  "19699-lbank", // GBEX
  "10275-lbank", // CATGIRL
  "25715-lbank", // MNTC
  "5690-lbank", // RNDR
  "4249-lbank", // FRA
  "30969-coinw", // RSIC
  "3890-woox", // MATIC
  "27659-kraken", // MOG
  "19856-coinex", // CAT
  "32461-xt", // neiro renamed
  "32464-ascendex", // neiro 2
];

function getScanInfo(exKey, coin, network) {
  const address = ExchangesAddresses[exKey]?.[network]?.[0];
  const token = coin.tokens?.[network]?.address;

  return getLinks(network, address, token);
}

function getLinks(network, holderAddress, tokenAddress) {
  if (holderAddress) {
    const links = NETWORKS_SCAN[network];
    return {
      address: holderAddress,
      ...links(holderAddress, tokenAddress),
    };
  }
}

module.exports = {
  Exchanges,
  ExchangesAddresses,
  fromExchanges,
  toExchanges,
  ignoreExchanges,
  ignoreCoins,
  ignoreCoinsMarket,
  getScanInfo,
  getLinks,
};
